<template>
	<div class="customerDetail">
		<el-row type="flex" class="row-bg" align="middle" justify="space-between">
			<!--标题 -->
			<div class="detail-title">
				<div class="detail-setmeal">{{ customers.businessLineName || '暂无' }}</div>
				<ig-icon name="qudaoshang" class="qudaoshang" v-if="customers.agentName != '-'"></ig-icon>
				<div style="margin: 0">
					<span v-if="customers.custName != '-'">{{ customers.custName }}</span>
					<span v-if="customers.primaryIndustryName != '-' || customers.secondIndustryName != '-'">
						<span v-if="customers.primaryIndustryName != '-'"
							>({{ customers.primaryIndustryName }}</span
						>
						<span v-if="customers.secondIndustryName">--{{ customers.secondIndustryName }})</span>
					</span>
					<span
						v-if="
							customers.foreignFirstIndustryName != '-' ||
							customers.foreignSecondIndustryName != '-'
						"
					>
						<span v-if="customers.foreignFirstIndustryName != '-'"
							>({{ customers.foreignFirstIndustryName }}</span
						>
						<span v-if="customers.foreignSecondIndustryName"
							>--{{ customers.foreignSecondIndustryName }})</span
						>
					</span>
				</div>
			</div>
			<!-- 订单确认 -->
			<el-row type="flex" align="bottom" v-if="activeName === 'service' && showConfirmation">
				<el-badge v-if="nums" :value="nums" class="circle orderSureButton">
					<el-button type="primary" @click.native="orderSure">订单确认</el-button>
				</el-badge>
			</el-row>
		</el-row>
		<!-- 信息卡片 -->
		<sky-card :cardList="cardList"></sky-card>
		<!-- 服务/订单列表 -->
		<el-row class="detail-list">
			<template>
				<el-tabs v-model="activeName">
					<el-tab-pane label="服务单" name="service">
						<services ref="servicesquery" :columns="servicesColumns"></services>
					</el-tab-pane>
					<el-tab-pane label="订单" name="indent">
						<indent ref="indentquery" :columns="indentColumns"></indent>
					</el-tab-pane>
				</el-tabs>
			</template>
		</el-row>
		<!-- 订单详情 -->
		<dialog-form
			:dialogVisible="dialogVisible"
			:showBtn="false"
			@close:dialogVisible="val => (dialogVisible = val)"
			:attributes="{
				width: '70%',
				title: '订单详情',
			}"
		>
			<div slot="main">
				<div class="order-info">
					<div class="order-code">
						<span>订单编号：</span>
						<span>{{ orderDetail.serviceCode }}</span>
						<span>（{{ orderDetail.orderTypeName }}）</span>
					</div>
					<div>
						套餐：{{ orderDetail.packageName || '-' }}
						<span v-if="orderDetail.packageVersionId"
							>（版本{{ orderDetail.packageVersionId }}）</span
						>
					</div>
					<div>录入时间：{{ orderDetail.createTime || '-' }}</div>
					<div>录入人：{{ orderDetail.createrName || '-' }}</div>
				</div>
				<data-list
					:table-style="{ name: 'mixture' }"
					:data="orderDetail.functionList"
					:columns="columns"
					:loading="loading"
				></data-list>
			</div>
		</dialog-form>

		<!-- 订单确认 -->
		<serviceconfirmation
			ref="serviceconfirmation"
			:orderList="orderList"
			:nextOrderCountTotal="nums"
			:orderType="orderType"
			:serviceConfirmation="serviceConfirmation"
			:agentName="agentName"
			@confirm="complete"
			@showOrderList="showOrderList"
		></serviceconfirmation>

		<!-- 操作验证 -->
		<el-dialog title="操作验证" :visible.sync="dialogVisibles" width="600px">
			<div class="hint">
				<ig-icon class="icon" name="remind1"></ig-icon>
				<p>当前操作需要主管授权，请选择主管后，向主管请求短信验证码</p>
			</div>
			<el-form ref="form" label-width="80px" size="small">
				<el-form-item label="选择主管">
					<el-select v-model="selectcontent" placeholder="请选择主管" @change="selectChange">
						<el-option
							v-for="item in list"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="code" label="验证码">
					<el-row>
						<el-col :span="15">
							<el-input v-model="VerificationCon"></el-input>
						</el-col>
						<el-col :span="6" style="margin-left: 28px">
							<el-button type="primary" @click="getVerificationCode" :disabled="disabled">
								{{ verificationCode }}
							</el-button>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibles = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" @click="updetaexpirationtime"
					>确认操作</el-button
				>
			</span>
		</el-dialog>

		<!-- 续费率图表 -->
		<dialog-form
			:dialogVisible="showDoalog"
			:attributes="attributes"
			:showBtn="false"
			@close:dialogVisible="val => (showDoalog = val)"
		>
			<radar-map
				slot="main"
				:showTitle="false"
				:showShadow="false"
				:chartData="chartData"
				:condition="condition"
				:extend="extend"
				:chartConfig="chartConfig"
				legendPosition="right"
			>
				<div class="average" slot="average">
					<div>
						<span class="data">客户预测续费率：{{ renewalRate.renewProb }}%</span>
						<span class="icon">
							<ig-icon
								:name="iconName(renewalRate.renewProbRise)"
								:style="{ color: iconStyle(renewalRate.renewProbRise) }"
							></ig-icon>
							{{ Math.abs(renewalRate.renewProbRise) }}%
						</span>
					</div>
					<div>
						<span class="data">行业平均预测续费率：{{ renewalRate.hyAvgRenewProb }}%</span>
						<span class="icon">
							<ig-icon
								:name="iconName(renewalRate.hyAvgRenewProbRise)"
								:style="{ color: iconStyle(renewalRate.hyAvgRenewProbRise) }"
							></ig-icon>
							{{ Math.abs(renewalRate.hyAvgRenewProbRise) }}%
						</span>
					</div>
				</div>
			</radar-map>

			<div class="radar-hint" slot="bottom">
				<div class="title">指标说明</div>
				<div>忠诚度：根据客户小程序/客户web端登录等数据评分</div>
				<div>价值：根据客户合作时间/提单频率/注册资金/消耗等数据评分</div>
				<div>服务情况：根据客户跟进等数据评分</div>
				<div>效果：根据询盘/询盘成本/网站浏览量/帖子浏览量等效果数据评分</div>
			</div>
		</dialog-form>

		<!-- 下载时间选择器 -->
		<dialog-form
			:dialogVisible="dateDoalog"
			:attributes="dateAttributes"
			@close:dialogVisible="val => (dateDoalog = val)"
			@confirm="confirm"
		>
			<date-switch-selector
				slot="main"
				:groups="timeSwitch"
				:lastDay="true"
				:lastMonth="true"
				timeTitle="选择报告周期："
				@reportData="reportData"
				:customDisabledDate="customDisabledDate"
			></date-switch-selector>
		</dialog-form>
		<!-- 查看日志 -->
		<dialog-form
			:dialogVisible="viewlogDialog"
			:attributes="viewlogAttributes"
			:showBtn="false"
			@close:dialogVisible="val => (viewlogDialog = val)"
		>
			<data-list
				slot="main"
				maxHeight="600"
				:table-style="{ name: 'mixture' }"
				:data="serviceLogData"
				:columns="serviceLogColumns"
			></data-list>
		</dialog-form>
	</div>
</template>

<script>
import rightControl from '@/components/customer/rightControl';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import api from '@/backend/apiConfig/apiConfig';
import customer from '@/backend/services/account/customer';
import { getTaskFlowList } from '@/backend/services/task/task';
import userSearch from '@/components/tools/userSearch';
import columnList from '@/components/tools/columnList';
import services from '@/components/setting/service';
import indent from '@/components/setting/indent';
import cardList from '@/components/customer/cardList.js';
import skyCard from '@/components/iglobalwin/formComponents/sky-card.vue';
import dialogForm from '@/components/dialogForm/dialogForm';
import radarMap from '@/components/sky_charts/radarMap.vue';
import dateSwitchSelector from '@/components/dateSwitchSelector/dateSwitchSelector.vue';
import { timeSwitch } from '@/common/dictionary.js';
import { GetMonthStr } from '@/utils/index.js';
import { getDateRegion } from '@/common/util.js';
import { judgeNullValue } from '@/utils/index.js';
import serviceconfirmation from '@/components/customer/serviceConfirmation.vue';
import serviceConfirmation from '@/components/customer/serviceConfirmation.js';
import serviceFunctionList from '@/components/customer/serviceFunctionList.vue';
import previewDueTime from './component/previewDueTime.vue';

import filter from '@/mixins/filters.js';
import { mapGetters } from 'vuex';
export default {
	name: 'customerDetail',
	components: {
		services,
		indent,
		skyCard,
		dialogForm,
		radarMap,
		dateSwitchSelector,
		serviceconfirmation,
	},
	data() {
		const that = this;
		const servicesColumns = [
			{
				label: '',
				type: 'tableExpand',
				width: 60,
				tagName: serviceFunctionList,
				refreshData() {
					that.$refs.servicesquery.query();
					that.$refs.indentquery.query();
				},
				getCode(valArr, name, id) {
					customer.leaders().then(val => {
						that.list = val.data;
						that.dialogVisibles = true;
						that.requestStatus = name;
						that.orderTime = valArr;
						that.orderId = id;
					});
				},
			},
			{
				label: '服务编号',
				bind: 'serviceCode',
				type: 'popoverView',
			},
			{
				label: '订单编号',
				bind: 'orderCode',
				type: 'popoverView',
			},
			{
				label: '套餐/功能',
				bind: 'setMealName',
				type: 'popoverView',
			},
			{
				label: '系统访问权限',
				type: 'custom',
				componentName: rightControl,
				inactiveValue: 0,
				activeValue: 1,
				bind: 'inform',
				event(row) {
					customer
						.getAppletAccess(row.id)
						.then(res => {
							if (res.status == 204) {
								row.inform = row.inform == 1 ? 0 : 1;
								that.$message.success('设置成功');
							}
						})
						.catch(() => {
							row.inform = row.inform == 1 ? 1 : 0;
							that.$message.error('设置失败');
						});
				},
			},
			{
				label: '创建/到期时间',
				type: 'multilineListItems',
				width: 190,
				itemsList: [
					{
						label: '创建时间',
						bind: 'formatCreateTime',
						type: 'columns',
						popoverWidth: '220',
						componentName: previewDueTime,
						iconStyle: {
							position: 'absolute',
							top: '11px',
							left: '100px',
							cursor: 'pointer',
						},
						dataList(val) {
							return [{ value: val, disabled: true }];
						},
					},
					{
						label: '到期时间',
						type: 'updialog',
						width: 220,
						bind: 'formatExpirationTime',
						isShowDia(row, time) {
							customer.leaders().then(val => {
								that.list = val.data;
							});
							let oldTime = row.formatExpirationTime;
							that.orderId = row.id;
							that.orderTime = time;
							that.requestStatus = 'time';
							if (oldTime !== time) {
								that.dialogVisibles = true;
							} else {
								this.$message({
									message: '请修改时间',
								});
							}
						},
					},
				],
				sort: 'formatExpirationTime',
				options: [
					{
						label: '由低到高',
						value: 'asc',
					},
					{
						label: '由高到低',
						value: 'desc',
					},
				],
			},
			{
				label: '服务单标签',
				bind: 'tagList',
				type: 'serviceSingleLabel',
				width: 300,
				event() {
					that.$refs.servicesquery.query();
				},
			},
			// {
			//   label: '业务线',
			//   bind: 'info',
			//   type: 'mapping',
			//   mapType: 'text',
			//   trigger: 'hover',
			// },
			{
				label: '服务单状态',
				bind: 'orderStatusName',
				align: 'center',
				getClass(row) {
					if (row.orderStatus === 1) {
						return 'normalText';
					}
					if (row.orderStatus === 2) {
						return 'deathText';
					}
					if (row.orderStatus === 3) {
						return 'deathText';
					}
					if (row.orderStatus === 4) {
						return 'danger';
					}
				},
			},
			{
				label: '续费情况',
				type: 'multilineListItems',
				itemsList: [
					{
						label: '续费状态',
						bind: 'renewalStatusName',
						type: 'percentage',
						dataStyle(val, row) {
							let { siteRenewalNum = 0, packageRenewalNum = 0 } = row;
							let total = packageRenewalNum + siteRenewalNum;
							if (val) {
								if (val === '首单') {
									return val;
								} else {
									return `${val}（${siteRenewalNum}/${total}）`;
								}
							} else {
								return '-';
							}
						},
					},
				],
			},
			{
				label: '操作',
				type: 'iconbutton',
				align: 'center',
				iconlist: [
					{
						name: 'chakanxiangqing',
						message: '查看日志',
						style: {
							color: '#333',
						},
						async callback(row) {
							let res = await customer.serviceLog({
								serviceId: row.id,
							});
							if (res.status === 200) {
								that.serviceLogData = res.data;
								that.viewlogDialog = true;
							} else {
								that.$message.info('请求错误');
							}
						},
					},
					{
						name: 'xiazai',
						message: '下载',
						style: {
							color: '#333',
						},
						showButton() {
							return that.getPermission(that.$permissionData.downloadRenewalRateReport.englishName);
						},
						async callback() {
							that.dateDoalog = true;
						},
					},
				],
			},
		];
		const indentColumns = [
			{
				label: '服务编号',
				bind: 'serviceCode',
				type: 'popoverView',
			},
			{
				label: '订单编号',
				bind: 'orderCode',
				type: 'popoverView',
			},
			{
				label: '套餐/平台',
				bind: 'packageName',
				type: 'popoverView',
			},

			{
				label: '录入时间',
				bind: 'formatCreateTime',
			},
			{
				label: '录入人',
				bind: 'createrName',
			},
			{
				label: '功能名称',
				bind: 'functionList',
				type: 'columns',
				disabled: true,
				dataList(val) {
					let data = val.map(item => {
						return {
							value: `${item.name} * ${item.purchaseQuantity * item.number}/${item.unitName}`,
						};
					});
					return data;
				},
			},
			{
				label: '订单状态',
				bind: 'statusName',
			},
			{
				label: '订单类型',
				bind: 'orderTypeName',
			},
			{
				label: '操作',
				type: 'iconbutton',
				align: 'center',
				iconlist: [
					// 查看
					{
						name: 'chakanxiangqing',
						message: '查看详情',
						style: {
							color: '#333',
						},
						async callback(row) {
							try {
								this.loading = true;
								let val = await customer.orderDetail(row.id);
								let { functionList } = val.data;
								if (!judgeNullValue(functionList)) {
									val.data.featureValue = functionList.map(item => {
										return `${item.name} * ${item.number * item.purchaseQuantity}/${
											item.unitName
										}、`;
									});
								}
								that.orderDetail = val.data;
								that.dialogVisible = true;
								this.loading = false;
							} catch (error) {
								this.loading = false;
							}
						},
					},
					// 删除
					{
						name: 'shanchu',
						message: '删除',
						style: {
							color: '#333',
						},
						showButton() {
							return that.getPermission(that.$permissionData.delete.englishName);
						},
						callback(row) {
							customer.leaders().then(val => {
								that.list = val.data;
							});
							that.orderId = row.id;
							that.requestStatus = 'delorder';
							that.dialogVisibles = true;
						},
					},
				],
			},
		];
		return {
			nums: '',
			orderType: '',
			agentName: null,
			serviceConfirmation: {},
			orderDetail: [],
			dialogVisible: false,
			orderDialogVisible: false,
			orderList: [],
			customers: {},
			btnLoading: false,
			servicesColumns: servicesColumns,
			indentColumns: indentColumns,
			activeName: 'service',
			dialogVisibles: false,
			verificationCode: '获取验证码',
			VerificationCon: '',
			disabled: false,
			list: [],
			selectcontent: '',
			orderId: '',
			orderTime: '',
			code: '', // 验证码
			requestStatus: '',
			cardList: cardList(),
			columns: [],
			showDoalog: false,
			attributes: {
				width: '50%',
				title: '',
			},
			timeSwitch,
			dateDoalog: false,
			dateAttributes: {
				width: '40%',
				title: '下载预测续费率报告',
			},
			chartData: [],
			condition: {},
			extend: {},
			chartConfig: {},
			ReportDateRange: '',
			renewalRate: {},
			viewlogDialog: false,
			viewlogAttributes: {
				width: '50%',
				title: '查看日志',
				top: '8vh',
			},
			serviceLogData: [],
			serviceLogColumns: {},
			loading: false,
		};
	},
	watch: {
		customerId: {
			handler(val) {
				if (!val) return false;
				this.$router.replace({ query: { id: val } });
				this.requestData();
				this.$refs.servicesquery.query();
				this.$refs.indentquery.query();
			},
		},
	},
	computed: {
		...mapGetters(['customerId']),
		showConfirmation() {
			return this.getPermission(this.$permissionData.orderConfirmation.englishName);
		},
	},
	methods: {
		requestData() {
			let id = this.$route.query.id;
			this.getOrderList(id);
			this.getCustomerDetail(id);
			this.setColumns();
		},
		setColumns() {
			let { rmb, money } = filter.filters;

			// 币种
			this.columns = [
				{
					label: '功能名称',
					bind: 'name',
					showOverflowTooltip: true,
				},
				{
					label: '功能版本',
					bind: 'version',
					showOverflowTooltip: true,
				},
				{
					label: '价格',
					bind: 'price',
					type: 'percentage',
					showOverflowTooltip: true,
					dataStyle(val, row) {
						let { currency } = row;
						return money(val, currency, true);
					},
				},
				{
					label: '量/时间',
					bind: 'totalNum',
					type: 'percentage',
					showOverflowTooltip: true,
					dataStyle(val, row) {
						return `${val}${row.unitName}`;
					},
				},
				{
					label: '总价',
					bind: 'singleFunctionTotalPrice',
					type: 'percentage',
					showOverflowTooltip: true,
					dataStyle(val, row) {
						let { currency } = row;
						return money(val, currency);
					},
				},
				{
					label: '优惠',
					bind: 'preferentialPrice',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency } = row;
						return money(val, currency);
					},
				},
				{
					label: '优惠后价格',
					bind: 'afterDiscount',
					type: 'percentage',
					dataStyle(val, row) {
						let { currency, singleFunctionTotalPrice, preferentialPrice } = row;
						return money(singleFunctionTotalPrice - preferentialPrice, currency);
					},
				},
				{
					label: '服务费',
					bind: 'functionTotalServiceFee',
					type: 'percentage',
					showOverflowTooltip: true,
					dataStyle(val, row) {
						let { currency } = row;
						if (val == 0) {
							return '-';
						} else {
							return money(val, currency);
						}
					},
				},
				{
					label: '税费',
					bind: 'functionTotalTaxFee',
					type: 'percentage',
					showOverflowTooltip: true,
					dataStyle(val, row) {
						let { currency } = row;
						if (val == 0) {
							return '-';
						} else {
							return money(val, currency);
						}
					},
				},
				{
					label: '实际充值',
					bind: 'functionTotalPrice',
					type: 'percentage',
					showOverflowTooltip: true,
					dataStyle(val, row) {
						let {
							functionTotalServiceFee: serviceFee,
							functionTotalTaxFee: taxFee,
							currency,
						} = row;
						if (serviceFee == 0 || taxFee == 0) {
							return '-';
						} else {
							return money(val - serviceFee - taxFee, currency);
						}
					},
				},
			];
			this.serviceLogColumns = [
				{
					label: '事项',
					bind: 'content',
					showOverflowTooltip: true,
				},
				{
					label: '操作人',
					bind: 'createrName',
					showOverflowTooltip: true,
				},
				{
					label: '操作时间',
					bind: 'createTime',
					showOverflowTooltip: true,
				},
			];
		},

		// 临时订单列表;
		async getOrderList(val) {
			let res = await customer.getOrderList({ customerId: val });
			this.nums = res.data.length;
			this.orderList = res.data;
			if (res.data.length === 0) return false;
			let id = this.orderList[0].id;
			this.getOrderListDeatail(id);
		},
		// 临时订单详情
		async getOrderListDeatail(val) {
			let res = await customer.getOrderListDeatail(val);
			// 功能
			let { functionList } = res.data;
			if (!judgeNullValue(functionList)) {
				res.data.featureValue = functionList.map(item => {
					return `${item.name} * ${item.number * item.purchaseQuantity}/${item.unitName} `;
				});
			}
			this.orderId = res.data.id;
			this.orderType = res.data.orderType;
			this.agentName = res.data.agentName;
			this.serviceConfirmations(res.data);
		},
		// 订单确认
		orderSure() {
			this.getOrderList(this.$route.query.id);
			this.$refs.serviceconfirmation.orderDialogVisible = true;
			this.orderDialogVisible = true;
		},
		// 获取任务流数据
		async getTaskFlowList(type) {
			let res = await getTaskFlowList({
				type,
			});
			return res.data;
		},
		showOrderList(val) {
			this.getOrderListDeatail(val);
		},
		complete(cb) {
			let that = this;
			that.btnLoading = true;
			simpleFormPageCreate(
				{
					api: api.customer.getTempOrder,
					type: 'Post',
					data: that.serviceConfirmation,
				},
				res => {
					let obj = Object.assign({}, res);
					obj.id = that.orderId;
					delete obj.customerInfo;
					delete obj.customerName;
					delete obj.industryType;
					delete obj.linkman;
					delete obj.infoList;
					delete obj.system;
					delete obj.expirationRate;
					delete obj.accountNumber;
					delete obj.website;
					delete obj.languageNumber;
					delete obj.google;
					delete obj.socialMedia;
					delete obj.platfromNumber;
					delete obj.opration;
					delete obj.FaceBook;
					delete obj.video;
					return obj;
				}
			)
				.submit()
				.then(res => {
					if (res.status !== 201) return false;
					if (that.nums > 1) {
						that.orderId = '';
						this.$refs.servicesquery.query();
						this.$refs.indentquery.query();
						that.btnLoading = false;
						that.getOrderList(that.$route.query.id);
					} else {
						this.$refs.servicesquery.query();
						this.$refs.indentquery.query();
						that.orderDialogVisible = false;
						that.orderId = '';
						that.btnLoading = false;
						that.getOrderList(that.$route.query.id);
					}
					cb();
				})
				.catch(() => {
					that.orderDialogVisible = true;
					that.btnLoading = false;
					cb(false);
				});
		},
		// 订单确认
		async serviceConfirmations(obj = {}) {
			let { getTaskFlowList } = this;
			let arr = [];
			try {
				arr[0] = await getTaskFlowList(0);
				arr[1] = await getTaskFlowList(1);
				arr[2] = await getTaskFlowList(2);
				arr[3] = await getTaskFlowList(3);
				arr[5] = await getTaskFlowList(5);
				arr[4] = await getTaskFlowList(4);
				arr[6] = await getTaskFlowList(6);
				arr[7] = await getTaskFlowList(7);
				arr[8] = await getTaskFlowList(10);
				arr[9] = await getTaskFlowList(21);
				arr[10] = await getTaskFlowList(22);
				arr[11] = await getTaskFlowList(23);
				this.serviceConfirmation = serviceConfirmation({
					obj,
					userSearch,
					arr,
				});
			} catch (error) {
				this.serviceConfirmation = serviceConfirmation({
					obj,
					userSearch,
					arr,
				});
			}
		},
		async getCustomerDetail(customerId) {
			let res = await customer.getCustomerDetail({ customerId });
			this.customers = res.data;
			// 数据处理
			Object.keys(res.data).forEach(key => {
				if (key == 'sslDueTime' && res.data[key]) {
					res.data[key] = res.data[key] && `${res.data[key]}到期`;
					return false;
				}
				if (key == 'mins' && res.data[key]) {
					res.data[key] = res.data[key] && `${res.data[key]}min`;
					return false;
				}
				if (key == 'taskCount' && res.data[key]) {
					res.data[key] = res.data[key] && `${res.data[key]}条`;
					return false;
				}
				if (res.data[key] === null) {
					res.data[key] = '-';
				}
			});
			// 卡片配置项
			this.cardList = cardList('array', res);
		},
		// 获取验证码
		async getVerificationCode() {
			if (!this.selectcontent) {
				this.$message({
					message: '请选择主管',
				});
				return false;
			}

			let time = 59;
			this.disabled = true;
			this.timeId = setInterval(() => {
				this.verificationCode = `(${time})重新获取`;
				if (time === 0) {
					this.verificationCode = '获取验证码';
					clearInterval(this.timeId);
					this.disabled = false;
				}
				time--;
			}, 1000);

			// 请求验证码
			let { selectcontent } = this;
			customer.verificationcode(selectcontent);
		},
		selectChange(val) {
			if (val) {
				this.disabled = false;
				this.verificationCode = '获取验证码';
				clearInterval(this.timeId);
			}
		},

		// 验证请求
		async updetaexpirationtime() {
			let { orderTime, orderId, selectcontent, VerificationCon, requestStatus } = this;
			if (!VerificationCon) {
				this.$message({
					message: '请输入验证码',
				});
				return false;
			}
			//设置访客识别中单月最大数量和结束时间
			if (requestStatus === 'visitor') {
				customer
					.visitors_to_identify(
						{
							code: VerificationCon,
							date: orderTime[1],
							functionNum: orderTime[0],
							userId: selectcontent,
						},
						{ id: orderId }
					)
					.then(res => {
						if (res.status === 204) {
							this.$message({
								message: '设置成功',
								type: 'success',
							});
						}
						this.dialogVisibles = false;
						this.$refs.servicesquery.query();
					})
					.catch(() => {
						this.$message({
							message: '设置失败',
							type: 'success',
						});
						this.dialogVisibles = false;
					});
			}

			// 设置到期时间
			if (requestStatus === 'time') {
				this.btnLoading = true;
				customer
					.expirationtime({
						id: orderId,
						code: VerificationCon,
						date: orderTime,
						userId: selectcontent,
					})
					.then(res => {
						if (res.status === 204) {
							this.$message({
								message: '设置成功',
								type: 'success',
							});
						}
						this.dialogVisibles = false;
						this.$refs.servicesquery.query();
					})
					.catch(() => {
						this.$message({
							message: '设置失败',
							type: 'success',
						});
						this.dialogVisibles = false;
					});
			}

			// 删除订单
			if (requestStatus === 'delorder') {
				this.btnLoading = true;
				let res = await customer.orderDelete({
					id: orderId,
					code: VerificationCon,
					userId: selectcontent,
				});
				if (res.status === 200) {
					this.$message({
						message: '设置成功',
						type: 'success',
					});
				}
				this.dialogVisibles = false;
				this.$refs.indentquery.query();
				this.$refs.servicesquery.query();
			}
			// 修改到期时间
			if (requestStatus === 'system') {
				let res = await customer.serviceEdit({
					id: orderId,
					serviceSystem: {
						code: VerificationCon,
						date: orderTime[0],
						systemFunctionNum: orderTime[1],
						tgDomain: orderTime[2],
						userId: selectcontent,
					},
				});

				if (res.status === 204) {
					this.$message.success('配置成功');
					this.dialogVisibles = false;
					this.$refs.servicesquery.query();
				}
			}
			// 修改语种数量
			if (requestStatus === 'website') {
				let res = await customer.updatelangeageNum({
					id: orderId,
					code: VerificationCon,
					functionNum: orderTime[0],
					sitePlatform: orderTime[1],
					userId: selectcontent,
				});

				if (res.status === 204) {
					this.$message.success('配置成功');
					this.dialogVisibles = false;
					this.$refs.servicesquery.query();
				}
			}

			// 需改edm剩余数量
			if (requestStatus === 'edm') {
				await customer.edmResidueNum({
					id: orderId,
					code: VerificationCon,
					functionNum: orderTime[0],
					userId: selectcontent,
				});

				this.$message.success('配置成功');
				this.dialogVisibles = false;
				this.$refs.servicesquery.query();
				console.log(serviceFunctionList);
			}

			// 云盘
			if (requestStatus === 'cloudDisk') {
				await customer.setCloudDiskNum({
					id: orderId,
					code: VerificationCon,
					functionNum: orderTime[0],
					sitePlatform: orderTime[1],
					userId: selectcontent,
				});

				this.$message.success('配置成功');
				this.dialogVisibles = false;
				this.$refs.servicesquery.query();
			}

			// SEO排名监控
			if (requestStatus === 'seoRank') {
				await customer.setSeoKeyWordNum({
					id: orderId,
					code: VerificationCon,
					functionNum: orderTime[0],
					userId: selectcontent,
				});
				this.$message.success('配置成功');
				this.dialogVisibles = false;
				this.$refs.servicesquery.query();
			}

			// 编辑智能网站访客识别的剩余月份和数量
			if (requestStatus === 'editMonthRemain') {
				await customer.editRemain(orderId, {
					code: VerificationCon,
					functionNum: orderTime,
					userId: selectcontent,
				});
				this.$message.success('修改成功');
				this.dialogVisibles = false;
			}

			// AI自动回复配置botId
			if (requestStatus === 'AiReply') {
				await customer.setAiReplyBotId({
					id: orderId,
					code: VerificationCon,
					botId: orderTime[0],
					userId: selectcontent,
				});
				this.$message.success('修改成功');
				this.dialogVisibles = false;
				this.$refs.servicesquery.query();
			}

			//  竞争对手分析配置
			if (requestStatus === 'compAnalysis') {
				await customer.setCompAnalysisNum({
					id: orderId,
					code: VerificationCon,
					userId: selectcontent,
					functionNum: orderTime[0],
					keywordNum: orderTime[1],
					backlinkNum: orderTime[2],
				});
				this.$message.success('修改成功');
				this.dialogVisibles = false;
				this.$refs.servicesquery.query();
			}

			//  AI创作配置
			if (requestStatus === 'aiCreative') {
				await customer.setAiCreativeNum({
					id: orderId,
					code: VerificationCon,
					userId: selectcontent,
					functionNum: orderTime[0],
				});
				this.$message.success('修改成功');
				this.dialogVisibles = false;
				this.$refs.servicesquery.query();
			}

			this.selectcontent = '';
			this.orderTime = '';
			this.orderId = '';
			this.VerificationCon = '';
			this.requestStatus = '';
			this.btnLoading = false;
		},
		reportData(val) {
			this.ReportDateRange = val;
		},
		async confirm(callback) {
			try {
				let val = this.ReportDateRange;
				let id = this.customers.id;
				let res = await customer.downloadRenewalRate({
					customerId: id,
					startDate: val.startDate,
					endDate: val.endDate,
				});
				if (judgeNullValue(res.data)) {
					this.$message.warning('暂无数据');
				}
				let fileName = decodeURI(res.headers['content-disposition']).split('=');
				let blob = new Blob([res.data]);
				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.style.display = 'none';
				link.href = url;
				link.setAttribute('download', fileName[1]);
				document.body.appendChild(link);
				link.click();
				callback && callback();
			} catch (error) {
				callback && callback();
			}
		},
		customDisabledDate(time, type) {
			if (type == 'WEEKLY') {
				//按周日为一周的最后一天计算
				var week = new Date();
				//今天是这周的第几天
				var today = week.getDay() * 24 * 3600 * 1000;
				return time.getTime() > Date.now() - today;
			}
			if (type == 'DAILY') {
				// 三个月的开始结束时间
				let date = GetMonthStr(3, 'day');
				let day = getDateRegion('DAY').split('至')[1];
				date.now = day;
				let start = new Date(date.now).getTime();
				return time.getTime() > start;
			}
			if (type == 'MONTHLY') {
				// 三个月的开始结束时间
				let end;
				let month = getDateRegion('MONTH').split('至')[1];
				end = new Date(month).getTime();
				return time.getTime() > end;
			}
		},
		iconName(val) {
			return parseFloat(val) > 0 ? 'shangsheng' : 'xiajiang';
		},
		iconStyle(val) {
			return parseFloat(val) > 0 ? '#F5222D' : '#52C41A';
		},
	},
	mounted() {
		this.requestData();
		window.FB.init({
			appId: '1399631517488334', // 替换为你的App ID
			xfbml: true, // 解析HTML标签中的Facebook标签（例如社交插件）
			version: 'v19.0', // SDK的版本号，根据需要选择合适的版本号
		});
	},
};
</script>

<style lang="scss" scoped>
.customerDetail {
	.row-bg {
		.detail-title {
			display: flex;
			justify-content: space-around;
			align-items: center;
			font-size: 18px;
			font-weight: bold;

			.detail-setmeal {
				width: 80px;
				height: 40px;
				background-color: #ffce3d;
				border-radius: 4px;
				color: #fff;
				font-size: 16px;
				text-align: center;
				line-height: 40px;
				margin-right: 16px;
				font-weight: normal;
			}
		}
	}
}

.checks {
	margin-top: 20px;
}

.orderSureButton {
	position: relative;
	margin-left: auto;
}

.default-color {
	background: rgb(201, 230, 241);
}

.title-customer {
	margin-bottom: 30px;
	font-weight: 600;
	font-size: 20px;
	display: flex;
	justify-content: space-between;

	.title {
		height: 34px;
		line-height: 34px;
	}

	.reorder {
		width: 72px;
		height: 34px;
		line-height: 34px;
		font-size: 16px;
		// background-color: rgba(84, 168, 254, 0.5);
		border: 1px solid #54a8fe;
		border-radius: 4px;
		color: #54a8fe;
		text-align: center;
		font-weight: 400;
	}
}

.circle {
	// margin-top: 10px;
	margin-right: 40px;
}
</style>
<style lang="scss" scoped>
.customerDetail {
	.dialogScroll {
		height: 100%;

		& > .el-scrollbar__wrap {
			overflow-x: hidden;
		}
	}

	.customer-active {
		background: rgb(201, 230, 241);
	}

	.customerListItem {
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 10px;
		user-select: none;
		cursor: pointer;
	}

	.customerListItem .order-code {
		margin-right: 6px;
	}

	.customerListItem .package-name {
		margin-left: 6px;
	}

	.detail-list {
		margin-top: 20px;
		position: relative;
	}

	.btn-top {
		position: absolute;
		top: -15px;
		right: 20px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.circle {
		height: 40px;
		// margin-top: 10px;
		margin-right: 40px;
	}

	.el-form {
		padding: 0 60px;

		.el-select--small {
			width: 100%;
		}
	}

	.hint {
		width: 100%;
		font-size: 14px;
		color: #333;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 15px 0 40px;

		.icon {
			color: #ffce3d;
			margin-right: 5px;
		}
	}

	.dialog-footer {
		width: 40%;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}

.average {
	line-height: 25px;

	.icon {
		margin-left: 10px;

		.iconfont {
			font-size: 12px;
		}
	}
}

.radar-hint {
	color: #333;
	font-size: 12px;
	line-height: 17px;
	margin-left: 20px;

	.title {
		font-weight: bold;
		margin-bottom: 5px;
	}
}

.order-info {
	color: #333;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;

	.order-code {
		font-weight: bold;
	}
}
.qudaoshang {
	font-weight: 400;
	font-size: 25px;
	margin-right: 10px;
	color: #67c23a;
}
</style>
